"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixPropertiesToJSON = exports.MixPropertiesFromJSONTyped = exports.MixPropertiesFromJSON = exports.instanceOfMixProperties = void 0;
var runtime_1 = require("../runtime");
var BackgroundMusic_1 = require("./BackgroundMusic");
/**
 * Check if a given object implements the MixProperties interface.
 */
function instanceOfMixProperties(value) {
    var isInstance = true;
    isInstance = isInstance && "backgroundMusic" in value;
    return isInstance;
}
exports.instanceOfMixProperties = instanceOfMixProperties;
function MixPropertiesFromJSON(json) {
    return MixPropertiesFromJSONTyped(json, false);
}
exports.MixPropertiesFromJSON = MixPropertiesFromJSON;
function MixPropertiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'backgroundMusic': (0, BackgroundMusic_1.BackgroundMusicFromJSON)(json['background_music']),
        'voiceStart': !(0, runtime_1.exists)(json, 'voice_start') ? undefined : json['voice_start'],
        'musicStart': !(0, runtime_1.exists)(json, 'music_start') ? undefined : json['music_start'],
        'musicVolume': !(0, runtime_1.exists)(json, 'music_volume') ? undefined : json['music_volume'],
        'duration': !(0, runtime_1.exists)(json, 'duration') ? undefined : json['duration'],
        'playFullMusic': !(0, runtime_1.exists)(json, 'play_full_music') ? undefined : json['play_full_music'],
    };
}
exports.MixPropertiesFromJSONTyped = MixPropertiesFromJSONTyped;
function MixPropertiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'background_music': (0, BackgroundMusic_1.BackgroundMusicToJSON)(value.backgroundMusic),
        'voice_start': value.voiceStart,
        'music_start': value.musicStart,
        'music_volume': value.musicVolume,
        'duration': value.duration,
        'play_full_music': value.playFullMusic,
    };
}
exports.MixPropertiesToJSON = MixPropertiesToJSON;
